<template>
  <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
    <div>
      <svg-icon class-name="international-icon" icon-class="language" style="font-size: 18px;margin:0 6px 0 0" />
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item :disabled="language==='zh'" command="zh">
        中文
      </el-dropdown-item>
      <el-dropdown-item :disabled="language==='en'" command="en">
        English
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import Cookies from 'js-cookie'
import app from '../../store/modules/app'
export default {
  computed: {
    language() {
      return this.$store.getters.language
    }
  },
  created() {
    console.log(this.language)
  },
  methods: {
    handleSetLanguage(lang) {
      this.$i18n.locale = lang
      console.log(this.$i18n.locale)
      Cookies.set('language', lang)
      app.state.language = lang
      //this.$store.dispatch('app/setLanguage', lang)
      let text = '切换成功'
      if (lang === 'en') text = 'Switch Language Success'
      if (lang === 'zhtw') text = '切換成功'
      this.$message({
        message: text,
        type: 'success'
      })
      setTimeout(() => {
        this.$router.go(0);
      }, 500);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LangSelect/index.vue